/**
 * Don't declare types in this file directly. Create a new file (or even new folder if it makes sense)
 * for exporting interface, then follow the existing statements here to re-export them.
 *
 * This is for organisation/clarity and easiness to import types.
 */

export * from './i18n';
export * from './shared';

export * from './components/ActionableDivider';
export * from './components/Forms';
export * from './components/Modal';
export * from './components/Navbar';
export * from './components/PageFrames';
export * from './components/Steps';

export * from './pages/ActivateEmail';
export * from './pages/ForgetPassword';
export * from './pages/Landing';
export * from './pages/Profile';
export * from './pages/ResetPassword';
export * from './pages/SignIn';
export * from './pages/SignOut';
export * from './pages/SignUp';
export * from './pages/UserInfo';

export * from './server-responses/EducationsEndpoint';
export * from './server-responses/JobsEndpoint';
export * from './server-responses/ProgramTopicsEndpoint';
export * from './server-responses/SelfEvaluationScoreEndpoint';
export * from './server-responses/UserEndpoint';


// WEBPACK FOOTER //
// ./src/types/index.ts